// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { FigmaCard } from './FigmaCard';

const figmaCard = EntityCardBlueprint.make({
  name: 'figma',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { FigmaCard } = await import('./FigmaCard');
      return <FigmaCard />;
    },
  },
});

export const figmaCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [figmaCard],
});
